import {ContactLeg, CreateReason, LegState} from "@sap/cpaas-commlib-lib";
import {Badge, Navbar} from "inferno-bootstrap";
import {T} from "inferno-i18next";

import {AgentInfo} from "../../components/agentinfo/AgentInfo";
import {Close} from "../../components/button/Close";
import {Minimize} from "../../components/button/Minimize";
import {AppState} from "../../services/configuration";
import {MessageType} from "../../services/messageProvider";
import {Level} from "../../utils/types";

export function Header(props: { alias:string, showUser: boolean, messageCount: number, minimized: boolean, onMinimize: (event: MouseEvent) => void, onClose: (event: MouseEvent) => void }) {
	return (
		<Navbar className="navbar-dark bg-primary header flex-nowrap chat-header">
			{(props.showUser ? <AgentInfo name={props.alias}/> : <div className="w-100"/>)}
			<p className="text-white mb-0 navbar-text w-100 text-center"><T i18nKey="VCC_XTIT_HEADER_TITLE">X</T></p>
			{props.messageCount > 0 && <Badge pill color={Level.Danger}>{props.messageCount}</Badge>}
			<div className="w-100 d-inline-flex justify-content-end">
				<Minimize minimized={props.minimized} onMinimize={props.onMinimize}/>
				<Close onClose={props.onClose}/>
			</div>
		</Navbar>
	);
}
